import * as React from 'react';
import * as ReactDOM from 'react-dom';
import ContextualCallout from './ContextualCallout';
import IFrameableDialog from './IFrameableDialog';
import TaskPaneCollection from './TaskPaneCollection';
import UILessAddinCommandsComponent from './UILessAddinCommandsComponent';

let frameworkComponent: HTMLDivElement;
export function lazyInitializeExtensibilityFrameworkComponent(
    renderTaskPaneInPanel: boolean
): void {
    if (frameworkComponent) {
        return;
    }

    frameworkComponent = document.createElement('div');
    document.body.appendChild(frameworkComponent);
    ReactDOM.render(
        <React.StrictMode>
            <ExtensibilityFrameworkComponent renderTaskPaneInPanel={renderTaskPaneInPanel} />
        </React.StrictMode>,
        frameworkComponent
    );
}

export function removeExtensibilityFrameworkComponent(): void {
    if (frameworkComponent == null) {
        return;
    }

    ReactDOM.unmountComponentAtNode(frameworkComponent);
    document.body.removeChild(frameworkComponent);
}

export interface ExtensibilityFrameworkComponentProps {
    renderTaskPaneInPanel: boolean;
}

export function ExtensibilityFrameworkComponent(props: ExtensibilityFrameworkComponentProps) {
    return (
        <div>
            {props.renderTaskPaneInPanel && <TaskPaneCollection renderTaskPaneInPanel={true} />}
            <UILessAddinCommandsComponent />
            <ContextualCallout />
            <IFrameableDialog />
        </div>
    );
}
